import { languageStorage } from '../storage/languageStorage';

/**
 * Utilidad para inyectar el header de idioma en una instancia de Axios
 * @param axiosInstance La instancia de axios a configurar
 * @param defaultLang Idioma por defecto si no hay nada en cache
 */
export const setLanguageHeader = (axiosInstance: any, defaultLang: string = 'es') => {
  if (!axiosInstance) return;

  const currentLang = languageStorage.getLanguage() || defaultLang;

  // Si axios tiene un objeto de configuración de headers
  if (axiosInstance.defaults && axiosInstance.defaults.headers) {
    axiosInstance.defaults.headers.common['Accept-Language'] = currentLang;
  }
};

/**
 * Sincroniza el idioma en Axios tras un cambio manual
 */
export const syncAxiosLanguage = (axiosInstance: any, lang: string) => {
  if (axiosInstance?.defaults?.headers?.common) {
    axiosInstance.defaults.headers.common['Accept-Language'] = lang;
  }
};
